import React from "react";

const DefaultLayout = ({ children }) => {
  return <div className="autonomos-default-layout">{children}</div>;
};

export default DefaultLayout;
